import type { ActionSource, FBEventMap, FBStandardEvent, GraphEvent, UserData } from "./types";

/** Build a Graph API event with sensible defaults */
export function buildEvent<E extends FBStandardEvent>(opts: {
  name: E;
  actionSource?: ActionSource;
  eventId?: string;
  eventSourceUrl?: string;
  user?: UserData;
  data?: FBEventMap[E];
  eventTime?: number; // seconds
}): GraphEvent<E> {
  const {
    name,
    actionSource = "website",
    eventId,
    eventSourceUrl,
    user,
    data,
    eventTime,
  } = opts;
  return {
    event_name: name,
    action_source: actionSource,
    event_time: eventTime ?? Math.floor(Date.now() / 1000),
    ...(eventId ? { event_id: eventId } : {}),
    ...(eventSourceUrl ? { event_source_url: eventSourceUrl } : {}),
    ...(user ? { user_data: user } : {}),
    ...(data ? { custom_data: data } : {}),
  };
}

/** Create a simple event_id when you do not have one (e.g., order id) */
export function createEventId(prefix = "evt"): string {
  // lightweight uuid-ish without deps
  const rnd = Math.random().toString(36).slice(2);
  const ts = Date.now().toString(36);
  return `${prefix}_${ts}_${rnd}`;
}
